var _g, _path, _path2, _circle, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconGoogleMarker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 44,
    viewBox: "0 0 33 44",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3498_230817)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 29,
    rx: 4,
    ry: 2,
    fill: "black",
    fillOpacity: 0.12
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6344 27.5869C28.0398 25.0842 30.25 21.0502 30.25 16.5C30.25 8.90608 24.0939 2.75 16.5 2.75C8.90608 2.75 2.75 8.90608 2.75 16.5C2.75 21.0502 4.9602 25.0841 8.36558 27.5869C10.9534 29.5368 14.6011 32.6129 15.4396 37.5643C15.5284 38.0888 15.9681 38.4958 16.5 38.4958C17.0319 38.4958 17.4716 38.0888 17.5604 37.5643C18.3989 32.6129 22.0466 29.5368 24.6344 27.5869Z",
    fill: "#EA382E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.933 27.988C28.4596 25.3949 30.75 21.2149 30.75 16.5C30.75 8.62994 24.3701 2.25 16.5 2.25C8.62994 2.25 2.25 8.62994 2.25 16.5C2.25 21.2149 4.54038 25.395 8.06708 27.988C10.6476 29.9327 14.1435 32.9057 14.9466 37.6478C15.0721 38.3892 15.701 38.9958 16.5 38.9958C17.299 38.9958 17.9279 38.3892 18.0534 37.6478C18.8565 32.9057 22.3525 29.9326 24.933 27.988Z",
    stroke: "url(#paint0_linear_3498_230817)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 5.5,
    fill: "black",
    fillOpacity: 0.4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3498_230817",
    x: 6,
    y: 25,
    width: 12,
    height: 8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_3498_230817"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3498_230817",
    x1: 16.5,
    y1: 2.75,
    x2: 16.5,
    y2: 38.4958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.35
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoogleMarker);
export default __webpack_public_path__ + "static/media/icon-google-marker.943e945f618c22cf66f31d80d8a8b3e1.svg";
export { ForwardRef as ReactComponent };